/**
 * The set of tab segments under `/jobs/:projectId/candidates/:conversationId/{tab}`.
 * The router's default redirect lands on `DEFAULT_CANDIDATE_TAB` when no tab is in the URL
 * (see `router/index.ts` — `:projectId/candidates/:conversationId?` redirects to
 * `job-resume-tab`), so this file is the single source of truth for that default.
 */
export const CANDIDATE_TABS = [
  'resume',
  'conversation',
  'applications',
  'notes',
  'contact',
] as const;

export type CandidateTab = (typeof CANDIDATE_TABS)[number];

export const DEFAULT_CANDIDATE_TAB: CandidateTab = 'resume';

/**
 * Pulls the candidate-detail tab segment from a `/jobs/.../candidates/.../{tab}` route
 * path. Matches only at the end of the path so spurious substrings (e.g.
 * `/conversation-extra`) do not match. Falls back to `DEFAULT_CANDIDATE_TAB`.
 */
export function getCurrentCandidateTab(routePath: string): CandidateTab {
  return CANDIDATE_TABS.find((tab) => routePath.endsWith(`/${tab}`)) ?? DEFAULT_CANDIDATE_TAB;
}
